import React from 'react';
import {
  Tabs,
} from '@chakra-ui/react';
import { TabList, TabPanels, Tab, TabPanel } from '@/components/ui/chakra-v2-compat';
import AdminPlanesCatalog from './AdminPlanesCatalog.jsx';
import AdminPlanesPanel from './AdminPlanesPanel.jsx';

const AdminPlanesHub = () => (
  <Tabs.Root colorPalette="purple" lazyMount>
    <Tabs.List px={6} pt={4}>
      <Tab value="0">Catálogo</Tab>
      <Tab value="1">Cuentas</Tab>
    </Tabs.List>
    <TabPanels>
      <TabPanel value="0" p={0}>
        <AdminPlanesCatalog />
      </TabPanel>
      <TabPanel value="1" p={0}>
        <AdminPlanesPanel />
      </TabPanel>
    </TabPanels>
  </Tabs.Root>
);

export default AdminPlanesHub;
